/*  ========================================================================
    # Scripts - Product Hero Animation
    ========================================================================  */

/**
 * Script that handles the product hero animation.
 */

const ProductHeroAnimation = {
  cfg: {
    productElement: document.querySelector('.s-product-hero__product'),
    productWrapperElement: document.querySelector('.s-product-hero__product-wrapper'),
    homeElement: document.querySelector('.s-product-hero__home'),
    bubbleElements: document.querySelectorAll('.s-product-hero__bubble'),
    states: {
      previousBubble: null
    }
  },

  /**
   * Handle button click.
   */
  handleProductAnimation() {
    const minProgress = 0.75;
    const maxProgress = 1;

    const handleScroll = () => {
      const productWrapperRect = this.cfg.productWrapperElement.getBoundingClientRect();
      const productRect = this.cfg.productElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress =
        minProgress +
        (maxProgress - minProgress) * ((productRect.height - productRect.top) / viewportHeight);

      if (productWrapperRect.top > 116 && progress < 1) {
        this.cfg.productWrapperElement.style.setProperty('--scroll-progress', progress);
      } else {
        this.cfg.productWrapperElement.style.setProperty('--scroll-progress', 1);
        this.cfg.productWrapperElement.style.opacity = 1;

        document.removeEventListener('scroll', handleScroll);
      }
    };

    // Initial progress
    setTimeout(() => {
      handleScroll();
      this.cfg.productWrapperElement.style.opacity = 1;
    }, 300);

    document.addEventListener('scroll', handleScroll, { passive: true });
  },

  /**
   * Handle bubble animation.
   */
  handleBubbleAnimation() {
    const interval = setInterval(() => {
      const bubbleIndex = Math.floor(Math.random() * this.cfg.bubbleElements.length);
      const bubbleElement = this.cfg.bubbleElements[bubbleIndex];
      if (bubbleIndex === this.cfg.states.previousBubble) {
        return;
      } else {
        this.cfg.states.previousBubble = bubbleIndex;
        bubbleElement.classList.add('scale');
        setTimeout(() => {
          bubbleElement.classList.remove('scale');
        }, 10000);
      }
    }, 11000);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.productWrapperElement) {
      this.handleProductAnimation();
    }

    if (this.cfg.bubbleElements && this.cfg.bubbleElements.length > 0) {
      this.handleBubbleAnimation();
    }
  }
};

export default ProductHeroAnimation;
